/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.watch.later.bff.rpc.WatchLaterBFFChirpService
 */
import * as References from './WatchLaterBFFChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.watch.later.bff.rpc.WatchLaterBFFChirpService#getItemsForWatchLaterPage
 */
export const GET_ITEMS_FOR_WATCH_LATER_PAGE_QUERY_FIELD_NAME = 'com_hubspot_watch_later_bff_rpc_WatchLaterBFFChirpService_getItemsForWatchLaterPage';
export const GET_ITEMS_FOR_WATCH_LATER_PAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ITEMS_FOR_WATCH_LATER_PAGE_QUERY_FIELD_NAME,
  args: ['searchTerm', 'hasCertification', 'contentTypes', 'durationFilters', 'visibilityGroup', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getItemsForWatchLaterPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});